import Glide from '@glidejs/glide'
import config from './config/config'
import { useStore } from 'vuex'
import { onMounted, ref } from 'vue'
import ProductCard from 'components/ProductCard/ProductCard'
import MaterialCard from 'components/MaterialCard/MaterialCard'
import SpotCardGrid from 'components/SpotCardGrid/SpotCardGrid'

const unifyCardHeight = function (root) {
    root.value.querySelectorAll('.glide__slide').forEach((slide) => {
        slide.style.height = `auto`
    })
}

export default {
    name: 'ProductsCardsSlider',
    components: { ProductCard, MaterialCard, SpotCardGrid },
    props: {
        glideBehaviour: {
            type: String,
            required: false,
            default: 'slider'
        },
        results: {
            type: Array,
            required: true
        },
        spotCardData: {
            type: Object,
            required: false
        },
        spotCardIndex: {
            type: Number,
            required: false
        },
        type: {
            type: String,
            required: false,
            default: 'products'
        },
        link: {
            type: Object,
            required: false
        },
        sliderId: {
            type: String,
            required: false
        }
    },
    setup(props) {
        const root = ref(null)
        const componentRootEl = ref(null)
        const store = useStore()
        const glidePosition = ref(0)

        const displayProperties = {
            products: { card: 'ProductCard' },
            materials: { card: 'MaterialCard' }
        }[props.type] ?? { card: 'ProductCard' }

        const getLabel = (labelKey) =>
            store.getters['labels/getLabel']({
                labelCollection: `productsCardsSlider-${props.sliderId}`,
                labelKey
            })

        const configFunction = function () {
            const glideBehaviour = props.glideBehaviour
            const viewportSize = document.documentElement.clientWidth
            return config({ glideBehaviour, viewportSize, startAt: glidePosition.value })
        }

        const truncateSummary = function (summary) {
            return summary.length > 120
                ? summary.substring(0, 117) + '...'
                : summary
        }

        const shouldRenderSpotCard = function (index) {
            // minus one to place correctly
            return props.spotCardIndex - 1 === index
        }

        onMounted(() => {
            unifyCardHeight(root)
            let sliderDOM = document.querySelector(`#${props.sliderId}`)

            if (!sliderDOM) return

            let glide = new Glide(`#${props.sliderId}`, configFunction())

            glide.on('resize', function () {
                glide.update(configFunction())
            })

            glide.on('move', function (e) {
                glidePosition.value = glide.index
            })

            glide.mount()

            document
                .querySelector('.glide')
                .addEventListener('keydown', function (event) {
                    // When tab key is pressed
                    if (event.keyCode == 9) {
                        var card = event.target?.parentNode
                        if (card == null) return

                        // Go to the next or previous card depending on whether it was a shift-tab
                        var nextCard = event.shiftKey
                            ? card.previousSibling
                            : card.nextSibling
                        var nextIndex =
                            nextCard?.attributes['data-index']?.value
                        if (nextIndex) glide.go('=' + nextIndex)
                    }
                })
        })

        return {
            displayProperties,
            componentRootEl,
            getLabel,
            root,
            link: props.link,
            truncateSummary,
            shouldRenderSpotCard
        }
    }
}
